import axios from "axios";
const SERVER = process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_BACKEND
      : "http://localhost:3001";
      console.log("trying to connect to backend in", SERVER);
      
const api = axios.create({
  baseURL:
  SERVER,
  // ✅ NO uses https.Agent en el navegador
});

export default api;
